import axios from 'axios';
import React, { useState } from 'react'
import SecurityHeaders from '../../context/SecurityHeaders';
import ENDPOINT from '../../context/EndPoint';
import SnackbarToast from '../toasts/SnackbarToast';
import { useDispatch } from 'react-redux';

const UpdateHackInternBatch = ({batch,handelClose,reload}) => {

    const dispatch = useDispatch()
      const [formData, setFormData] = useState({
            batch_name: batch.batch_name,
            start_date: batch.start_date,
            end_date: batch.end_date, 
            morning_slot: batch.morning_slot,
            afternoon_slot: batch.afternoon_slot,
            evening_slot: batch.evening_slot,
        });
          // Handle input change
    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };
    const [open, setOpen] = useState({
        open: false,
        message: '',
      type: ''
    
      });
    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();
        dispatch({type:'LOADING'})
        const data = new FormData()
        data.append('batch_name', formData.batch_name);
        data.append('end_date', formData.end_date);
        data.append('start_date', formData.start_date);
        data.append('morning_slot', formData.morning_slot);
        data.append('afternoon_slot', formData.afternoon_slot);
        data.append('evening_slot', formData.evening_slot);
        data.append('internship_id',batch.internship_id)
 
        try{
            dispatch()
            const response = await axios.post(ENDPOINT + "update-hacking-internship-batch.php", data, SecurityHeaders)

            if (response.data.status === "success") {
                dispatch({type:'DONE_LOADING'})
                setOpen({
                    open: true,
                    message: response.data.message,
                    type: response.data.status,
                });
                setFormData({
                    batch_name: "",
                    start_date: "",
                    end_date: "",
                    morning_slot: "",
                    afternoon_slot: "",
                    evening_slot: "",
                });
                reload()
                handelClose()
            }
            else {
                dispatch({
                  
                    payload: response.data.message,
                    type: 'ERROR',
                });
            }
        }
        catch(error){
            dispatch({
                type: 'ERROR',
                payload:error.message ,
            });
        }

    };
   
  return (
    <>
    <SnackbarToast open={open} handleClose={()=>setOpen((pre)=>({...pre,open:false}))} />

              <div className="container mt-4">
                        <h2 className="mb-3">Update Internship Batch</h2>
                   

                        <form onSubmit={handleSubmit}>
                            <div className="mb-3">
                                <label className="form-label">Batch Name</label>
                                <input type="text" name="batch_name" className="form-control" value={formData.batch_name} onChange={handleChange} required />
                            </div>

                            <div className="mb-3">
                                <label className="form-label">Start Date</label>
                                <input type="date" name="start_date" className="form-control" value={formData.start_date} onChange={handleChange} required />
                            </div>

                            <div className="mb-3">
                                <label className="form-label">End Date</label>
                                <input type="date" name="end_date" className="form-control" value={formData.end_date} onChange={handleChange} required />
                            </div>

                            <div className="mb-3">
                                <label className="form-label">Morning Slot</label>
                                <select type="text" name="morning_slot" className="form-control" value={formData.morning_slot} onChange={handleChange} >
                                    <option value="">Select Slot</option>
                                    <option value="Almost filled">Almost filled</option>
                                    <option value="Few seats left">Few seats left                                    </option>
                                    <option value="Available">Available</option>
                                </select>
                            </div>

                            <div className="mb-3">
                                <label className="form-label">Afternoon Slot</label>
                                <select type="text" name="afternoon_slot" className="form-control" value={formData.afternoon_slot} onChange={handleChange} >
                                <option value="">Select Slot</option>
                                    <option value="Almost filled">Almost filled</option>
                                    <option value="Few seats left">Few seats left                                    </option>
                                    <option value="Available">Available</option>
                                    </select>
                            </div>

                            <div className="mb-3">
                                <label className="form-label">Evening Slot</label>
                                <select type="text" name="evening_slot" className="form-control" value={formData.evening_slot} onChange={handleChange} >
                                    <option value="">Select Slot</option>
                                    <option value="Almost filled">Almost filled</option>
                                    <option value="Few seats left">Few seats left                                    </option>
                                    <option value="Available">Available</option>
                                    </select>
                            </div>

                            <button type="submit" className="btn btn-primary">Submit</button>
                        </form>
                    </div>
      
    </>
  )
}

export default UpdateHackInternBatch
